// extracted by mini-css-extract-plugin
module.exports = {"root":"Searchbar_root__i4oSJ","input":"Searchbar_input__NfaB1","iconContainer":"Searchbar_iconContainer__1Tln2","icon":"Searchbar_icon__fajpH"};